import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import { Button, Checkbox, Col, Input, Radio, Row, Select } from 'antd';
import { Erase } from '@carbon/icons-react';
import { isEmpty } from 'underscore';
import dayjs from 'dayjs';
import { triggerErrorNotification } from '../../../core/utils/notificationUtils';

const { REGEX_VALID_EMAIL, REGEX_VALID_HOURS_MINS } = require('../../../core/constants').default;
class GeoFence extends Component {
    constructor(props) {
        super(props);
        this.weekdays = dayjs.weekdays();
        this.state = {
            emailIsInvalid: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initializeValues !== this.props.initializeValues) {
            this.props.form.resetFields();
        }
    }

    submitForm = (e) => {
        const { onSubmit, form } = this.props;

        e.preventDefault();

        let emails = form.getFieldValue('emails');
        if (emails?.length && emails[emails.length - 1] === ',') { // remove trailing comma
            emails = emails.slice(0, emails.length - 1);
        }
        let emailIsEmpty = false;
        let emailIsInvalid = false;
        if (emails?.length) {
            // Split on comma or semicolon, trim, and filter out empty strings
            const emailList = String(emails)
                .split(/[;,]/)
                .map(email => email.trim())
                .filter(email => email.length > 0);
            if (emailList.length === 0) {
                emailIsEmpty = true;
            }
            emailList.forEach(email => {
                if (!email) {
                    emailIsEmpty = true;
                } else if (!email.match(REGEX_VALID_EMAIL)) {
                    emailIsInvalid = true;
                }
            });
        }
        if (emailIsEmpty) {
            triggerErrorNotification('Email addresses cannot be empty');
            return;
        }
        if (emailIsInvalid) {
            triggerErrorNotification('One or more email addresses are invalid.');
            return;
        }

        this.props.form.validateFields((err, values) => {
            if (!err) {
                // Ensure time_active_start and time_active_end are dayjs objects
                if (values.time_active_start && typeof values.time_active_start === 'string') {
                    values.time_active_start = dayjs(values.time_active_start, 'HH:mm');
                }
                if (values.time_active_end && typeof values.time_active_end === 'string') {
                    values.time_active_end = dayjs(values.time_active_end, 'HH:mm');
                }
                onSubmit(values);
            }
        });
    };

    componentWillUnmount() {
        this.props.form.resetFields();
    }

    render() {
        const {
            divisions, assets, form, initializeValues,
        } = this.props;
        const { isVisibleEmailError } = this.state;

        const { getFieldDecorator } = form;
        const initialDaysActive = this.weekdays.reduce((carry, day) => {
            if (initializeValues?.days_active?.[day] == true) {
                carry.push(day);
            }
            return carry;
        }, []);
        let initialDivisions = [];
        let initialAssets = [];
        if (!isEmpty(initializeValues?.divisions)) {
            initialDivisions = initializeValues.divisions.map((division) => division.id);
        }

        if (!isEmpty(initializeValues?.assets)) {
            initialAssets = initializeValues.assets.map((asset) => asset.id);
        }

        return (
            <>
                <h5 className="h-5">Edit Geo-Fence</h5>
                <div style={{
                    textAlign: 'left',
                    alignItems: 'left',
                    width: '100%'
                }}>
                    <Form onSubmit={this.submitForm}>
                        <Row style={{ marginTop: '16px' }}>
                            <Col><span className='modal-label'>Name</span></Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <Form.Item label={null}>
                                    {getFieldDecorator('trigger_name', {
                                        initialValue: initializeValues && initializeValues.name ? initializeValues.name : null,
                                    })(
                                        <Input
                                            type="text"
                                            placeholder="Enter Geo-fence Name"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '16px' }}>
                            <Col>
                                <span className='modal-label'>Emails</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <Form.Item label="">
                                    {getFieldDecorator('emails', {
                                        initialValue: initializeValues?.emails?.split(',').join(', ') || '',
                                    })(
                                        <Input.TextArea
                                            rows={3}
                                            style={{ height: '90px' }}
                                            onChangeCapture={(e) => {
                                                let emailIsInvalid = false;
                                                let emails = e.currentTarget.value;
                                                // Split on comma or semicolon, trim, and filter out empty strings
                                                const emailList = String(emails)
                                                    .split(/[;,]/)
                                                    .map(email => email.trim())
                                                    .filter(email => email.length > 0);
                                                emailList.forEach(email => {
                                                    if (!email.match(REGEX_VALID_EMAIL)) {
                                                        emailIsInvalid = true;
                                                    }
                                                });
                                                this.setState({ isVisibleEmailError: emailIsInvalid });
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            {isVisibleEmailError && (
                                <p style={{
                                    color: 'var(--red)',
                                    fontSize: 12,
                                    fontWeight: 'normal',
                                    width: '100%',
                                    textAlign: 'center',
                                    marginBottom: 0,
                                    marginTop: -4,
                                }}>
                                    An entered email is invalid!
                                </p>
                            )}
                        </Row>
                        <Row style={{ marginTop: '16px' }}>
                            <Col>
                                <span className='modal-label'>Alerts will be sent</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={1} />
                            <Col span={23}>
                                <Form.Item
                                    label={null}
                                    style={{ marginBottom: '8px' }}
                                >
                                    {getFieldDecorator('days_active', {
                                        initialValue: initialDaysActive,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Please select at least one day',
                                            },
                                        ]
                                    })(
                                        <Checkbox.Group style={{ width: '100%' }}>
                                            <Row>
                                                {this.weekdays.map(day => {
                                                    return (
                                                        <Col span={8} key={'active-days-' + day}>
                                                            <Checkbox value={day}>{day}</Checkbox>
                                                        </Col>
                                                    )
                                                })}

                                            </Row>
                                        </Checkbox.Group>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Form.Item
                                label={null}
                                style={{ marginBottom: '8px' }}
                            >
                                {getFieldDecorator('active_inside', {
                                    initialValue: initializeValues.active_inside,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please select if it should be inside or outside the hours',
                                        },
                                    ],
                                })(
                                    <>
                                        &ensp;&thinsp;
                                        <Radio.Group>
                                            <Radio value={1}>Between</Radio>
                                            <Radio value={0}>Outside Of</Radio>
                                        </Radio.Group>
                                    </>
                                )}
                            </Form.Item>
                            <Form.Item
                                label=""
                                style={{
                                    display: "inline-block",
                                    width: "50%",
                                    paddingRight: "5px",
                                }}
                            >
                                {getFieldDecorator('time_active_start', {
                                    initialValue: dayjs(initializeValues.time_active_start, 'HH:mm:ss').format('HH:mm'),
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please select the hours from',
                                        },
                                        {
                                            pattern: REGEX_VALID_HOURS_MINS,
                                            message: 'Must be in HH:MM format!',
                                        },
                                    ],
                                })(
                                    <Input />
                                )}
                            </Form.Item>
                            <Form.Item
                                label=""
                                style={{
                                    display: "inline-block",
                                    width: "50%",
                                    paddingLeft: "5px"
                                }}
                            >
                                {getFieldDecorator('time_active_end', {
                                    initialValue: dayjs(initializeValues.time_active_end, 'HH:mm:ss').format('HH:mm'),
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please select the hours to',
                                        },
                                        {
                                            pattern: REGEX_VALID_HOURS_MINS,
                                            message: 'Must be in HH:MM format!',
                                        },
                                    ],
                                })(
                                    <Input />
                                )}
                            </Form.Item>
                        </Row>

                        <Row style={{ marginTop: '16px' }}>
                            <Col>
                                <span className='modal-label'>Affects</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={1} />
                            <Col span={23}>
                                <Form.Item
                                    label={null}
                                    style={{ marginBottom: '0px' }}
                                >
                                    {getFieldDecorator('filter_by', {
                                        initialValue: initializeValues?.filter_by ?? '',
                                    })(
                                        <Radio.Group>
                                            <Radio value={''}>All assets</Radio>
                                            <Radio value='division'>Selected Divisions</Radio>
                                            <br />
                                            <Radio value='asset'>Selected Assets</Radio>
                                        </Radio.Group>,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {form.getFieldValue('filter_by') == "division"
                            ? (
                                <Row style={{ marginTop: '10px' }}>
                                    <Col span={1} />
                                    <Col span={23}>
                                        <Form.Item label={null} >
                                            {getFieldDecorator('divisions', {
                                                initialValue: initialDivisions,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please select divisions!',
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    mode="multiple"
                                                    value={initialDivisions}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select Division"
                                                    filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                                                    allowClear={<Erase size={12} />}
                                                    showSearch
                                                >
                                                    {divisions ? divisions.map((division, divisionIndex) => <Select.Option key={`index-${divisionIndex}`} value={division.id}>{division.name}</Select.Option>) : null}
                                                </Select>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            )
                            : null}
                        {form.getFieldValue('filter_by') == "asset"
                            ? (
                                <Row style={{ marginTop: '10px' }}>
                                    <Col span={1} />
                                    <Col span={23}>
                                        <Form.Item label={null}>
                                            {getFieldDecorator('assets', {
                                                initialValue: initialAssets,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please select assets!',
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    mode="multiple"
                                                    style={{ width: '100%' }}
                                                    placeholder="Select Asset"
                                                    filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                                                    allowClear={<Erase size={12} />}
                                                    showSearch
                                                >
                                                    {assets ? assets.map((asset, assetsIndex) => <Select.Option key={`index-${assetsIndex}`} value={asset.id}>{asset.name}</Select.Option>) : null}
                                                </Select>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            )
                            : null}
                        <div style={{ textAlign: 'center' }}>
                            <Button
                                htmlType="submit"
                                type="primary"
                            >
                                &ensp;Save&ensp;
                            </Button>
                        </div>
                    </Form>
                </div>
            </>
        );
    }
}

GeoFence.propTypes = {
    divisions: PropTypes.array,
    assets: PropTypes.array,
    initializeValues: PropTypes.object,
};

GeoFence.defaulProps = {
    divisions: [],
    assets: [],
};

const GeoFenceForm = Form.create({ name: 'event_filter_form' })(GeoFence);

export default GeoFenceForm;
